<template>
 <AdminPanelMegogoPackageSellingHistoryEdit />
</template>

<script>
import AdminPanelMegogoPackageSellingHistoryEdit  from '../components/AdminPanelMegogoPackageSellingHistoryEdit.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelMegogoPackageSellingHistoryEdit
    },
    methods: {},
    mounted() {}
}
</script>
